export const convertStringTo = (string: string, type: 'camelCase' | 'hyphenated') => {
    if (type === 'camelCase') {
        return string.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    }
    return string.replace(/([a-z][A-Z])/g, (g) => g[0] + '-' + g[1]).toLowerCase();
};

export const capitalize = (string: string) => {
    if (!!string) {
        string = string.toLowerCase();
        return string[0].toUpperCase() + string.slice(1);
    }
    return string;
};
